import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { i18n } from '../../translate/i18n';
import {
  Paper, Typography,
} from '@mui/material';
import { Container } from '../../components/Calendar/EventModal/EventModalCard/CardTypes/card.style';
import { formatTitle, formatLabel, borderColor } from '../../utils/equipmentLogCardLabel';

const branchWidth = 25;
const branchBorderSize = 4;
const bulletSize = 12;

const styles = {
  nameContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  labelDocType: {
    fontSize: 12,
  },
  labelStatus: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  title: {
    fontSize: '1.2rem',
    color: 'green',
  },
  description: {
    fontSize: '1rem',
    color: 'black',
  },
  date: {
    fontSize: '0.7rem',
    width: '100%',
    textAlign: 'right',
    paddingTop: 10,
  },
  branch: {
    width: branchWidth,
    backgroundColor: 'grey',
  },
  bullet: {
    width: bulletSize,
    height: bulletSize,
    backgroundColor: 'grey',
    borderRadius: bulletSize,
    margin: (-bulletSize / 2) - branchBorderSize / 2,
  },
  triangle: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '15px 0 15px 15px',
    borderColor: 'transparent transparent transparent #fff',
    filter: 'drop-shadow(2px 0 0 #e6e6e6) drop-shadow(0 0.5px 0 #e6e6e6)',
    marginLeft: -2,
  },
  responsibleTitle: {
    fontSize: '0.8rem',
    fontWeight: 'bolder',
  },
  responsibleContent: {
    fontSize: '1rem',
  },
  footer: {
    marginTop: '0.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: '0.7rem',
  },
  equipmentName: {
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  label: {
    color: "#828282",
    fontSize: "0.8rem"
  },
  dataContainer: {
    marginTop: 10
  },
  data: {
    marginTop: -3,
    textAlign: 'left'
  }
};

export default function ActionLogsCardTimeline(props) {
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRight: props.index % 2 === 0 && `${branchBorderSize}px solid grey`,
    marginRight: props.index % 2 === 0 && `calc(25rem + ${branchWidth - branchBorderSize}px)`,
    borderLeft: props.index % 2 === 1 && `${branchBorderSize}px solid grey`,
    marginLeft: props.index % 2 === 1 && `calc(25rem + ${branchWidth - branchBorderSize}px)`,
    boxSizing: 'border-box',
    marginTop: '-2rem',
  };

  return (
    <div style={containerStyle}>
      {props.index % 2 === 1
        && (
          <>
            <div style={styles.bullet} />
            <div style={styles.branch} />
          </>
        )
      }

      <PaperStyled>
        <Container borderColor={borderColor(props)} style={{ marginBottom: 0 }}>
          <div style={styles.nameContainer}>
            <div style={styles.dataContainer}>
              <div style={{ ...styles.data, textTransform: 'uppercase' }} dangerouslySetInnerHTML={{ __html: formatTitle(props) }}></div>
            </div>
          </div>
          <div style={styles.dataContainer}>
            <div style={styles.label}>{i18n.t('divActionLogs.update')}</div>
            <div style={styles.data} dangerouslySetInnerHTML={{ __html: formatLabel(props) }}></div>
          </div>
          {props.changeStatus && props.changeStatus.comment && <div style={styles.dataContainer}>
            <div style={styles.label}>{i18n.t('divActionLogs.comments')}</div>
            <div style={styles.data}>{props.changeStatus.comment}</div>
          </div>}
          {props.changeMaintenanceStatus && props.changeMaintenanceStatus.comment && <div style={styles.dataContainer}>
            <div style={styles.label}>{i18n.t('divActionLogs.comments')}</div>
            <div style={styles.data}>{props.changeMaintenanceStatus.comment}</div>
          </div>}
          <div style={{ ...styles.date }}>{i18n.t('divActionLogs.update_at')} {props.createdAt && moment(props.createdAt).format('DD/MM/YYYY')} ás {props.createdAt && moment(props.createdAt).format('HH:mm')}</div>
        </Container>
      </PaperStyled>
      {
        props.index % 2 === 0
        && (
          <>
            <div style={styles.branch} />
            <div style={styles.bullet} />
          </>
        )
      }
    </div>
  );
}

const PaperStyled = styled(Paper)`
  width: 25rem;
  padding: 0px;
  opacity: ${props => (props.spinner ? 0.5 : 1)};
  margin-bottom: 40px;
  overflow: hidden;
`;
